import { LIST_TYPES_DATABASES } from "../../pages/NewManagerDatabasesPage/constants";
import {
    CustomerDatabaseFormKey,
    CustomerDatabaseFormValues,
    ICustomerDatabaseProps,
} from "./types";

const mysql = 1;
const mongodb = 2;

const customerDatabaseLabels: Record<CustomerDatabaseFormKey, string> = {
    backup_enabled: "Backup habilitado",
    customer_database_type: "Tipo do banco",
    database_name: "Nome do banco",
    ip: "IP",
    password: "Senha",
    port: "Porta",
    user: "Usuário",
};

const customerDatabaseFields: CustomerDatabaseFormKey[] = [
    "backup_enabled",
    "customer_database_type",
    "database_name",
    "ip",
    "password",
    "port",
    "user",
];

const customerDatabaseGridFields: CustomerDatabaseFormKey[] = [
    "customer_database_type",
    "database_name",
    "ip",
    "password",
    "port",
    "user",
];

const emptyCustomerDatabaseValues: CustomerDatabaseFormValues = {
    backup_enabled: false,
    customer_database_type: "",
    database_name: "",
    id: "",
    ip: "",
    password: "",
    port: "",
    user: "",
};

const mapCustomerDatabaseToFormValues = (
    customerDatabase?: ICustomerDatabaseProps
): CustomerDatabaseFormValues => {
    return {
        backup_enabled: Boolean(customerDatabase?.backup_enabled),
        customer_database_type: String(
            customerDatabase?.customer_database_type_id
        ),
        database_name: customerDatabase?.database_name ?? "",
        id: String(customerDatabase?.id ?? ""),
        ip: customerDatabase?.ip ?? "",
        password: customerDatabase?.password ?? "",
        port: String(customerDatabase?.port ?? ""),
        user: customerDatabase?.user ?? "",
    };
};

const getNameDatabaseById = (database_type_id: string | number) => {
    const databaseNameId = LIST_TYPES_DATABASES.find(
        (data) => data.id === Number(database_type_id)
    )?.name;

    if (databaseNameId) return databaseNameId.toLocaleUpperCase();

    return "Não informado";
};

const clouds = ["gcp", "aws", "digitalocean", "infra704"];

export {
    mysql,
    mongodb,
    customerDatabaseLabels,
    customerDatabaseFields,
    customerDatabaseGridFields,
    emptyCustomerDatabaseValues,
    mapCustomerDatabaseToFormValues,
    getNameDatabaseById,
    clouds,
};
